import React from 'react'
import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
// import AsyncSelect from 'react-select/async'
import AsyncCreatableSelect from 'react-select/async-creatable'
import Select from 'react-select'
import { ClientSideTable } from 'Presentation/Components/Table'
import Datetime from 'react-datetime'

import ItemForm from './Components/ItemForm'

import useViewModel from './ViewModel'
import clsx from 'clsx'
import moment from 'moment'
import { Link } from 'react-router-dom'

const SaleOrderFormView: React.FC = () => {
  const {
    // Form
    isView,
    isCreate,
    isOversea,
    isLoadingCustomer,
    // isFocusCustomer,
    // setIsFocusCustomer,
    // jobStatusOptions,
    cancel,
    handleSubmit,
    formState,
    versions,
    onChange,
    provincesOptions,
    districtOptions,
    subDistrictOptions,
    zipCodeSelected,
    customerOptions,
    errors,
    disalbedSubmitButton,
    onSearchCustomer,
    onSelectCustomer,
    // Items
    itemsData,
    ITEMS_COLUMNS_CONFIG,
    formStateItem,
    onChangeItem,
    showItemForm,
    closeItemForm,
    createItem,
    itemFormType,
    onSubmitItem,
    errorItem,
    onDuplicate,
  } = useViewModel()

  return (
    <ViewPageTitle isCreate={isCreate} code={formState.code} version={formState.revision}>
      <ItemForm
        open={showItemForm}
        handleClose={closeItemForm}
        formType={itemFormType}
        formState={formStateItem}
        onChange={onChangeItem}
        onSubmit={onSubmitItem}
        errorItem={errorItem}
      />

      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <div className='card border border-2'>
        {/* begin:: Header */}
        <div className='card-header'>
          <div className='card-title fw-bold'>
            {/* {isCreate ? 'Create Sale Order' : 'Sale Order Detail'} */}
          </div>
          <div className='card-toolbar'>
            {!isView && (
              <>
                <button className='btn btn-sm btn-secondary fw-bold me-4' onClick={cancel}>
                  ยกเลิก
                </button>
                <button className='btn btn-sm btn-primary fw-bold  me-4' onClick={onDuplicate}>
                  สร้าง Version ใหม่
                </button>
                <button
                  className='btn btn-sm btn-primary fw-bold'
                  onClick={handleSubmit}
                  disabled={disalbedSubmitButton}>
                  บันทึก
                </button>
              </>
            )}
          </div>
        </div>

        <div className={'card-body'}>
          <div className='row gy-3'>
            <div className='col-12'>
              {versions && versions.length > 0 && (
                <div className=''>
                  <div className='fw-bold'>ประวัติการแก้ไข</div>
                  {versions.map((version, idx) => (
                    <div key={idx}>
                      <Link to={`/sale-order/${version.id}`}>
                        Version {version.revision} : สร้างขึ้นเมื่อวันที่{' '}
                        {moment(version.createdAt).format('DD/MM/YYYY')}
                      </Link>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Row 1 */}
            <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                Sale Order ID. <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': errors.code,
                })}
                placeholder='S001-001'
                value={formState.code}
                onChange={(e: any) => onChange('code', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                ชื่อหน่วยงาน <span className='required' />
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': errors.division,
                })}
                value={formState.division ?? ''}
                onChange={(e: any) => onChange('division', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                ผู้ขาย
                <span className='required'></span>
              </label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': errors.saleTitle,
                })}
                value={formState.saleTitle ?? ''}
                onChange={(e: any) => onChange('saleTitle', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                วันที่ส่งเอกสาร <span className='required' />
              </label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                renderInput={props => {
                  return (
                    <input
                      {...props}
                      autoComplete='off'
                      className={clsx(props.className, {
                        'is-invalid': errors.deliveryDocumentDate,
                      })}
                    />
                  )
                }}
                closeOnClickOutside
                className='filter-date-input w-100 z-4'
                value={formState.deliveryDocumentDate}
                onChange={(val: any) => onChange('deliveryDocumentDate', val)}
              />
            </div>

            {/* Row 2 */}
            <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                ชื่อลูกค้า <span className='required' />
              </label>
              <AsyncCreatableSelect
                cacheOptions
                defaultOptions={customerOptions}
                value={
                  customerOptions.find(opt => opt.label === formState.customerTitle) ?? {
                    label: formState.customerTitle,
                    value: formState.customerTitle,
                  }
                }
                placeholder='กรุณากรอกชื่อลูกค้า'
                noOptionsMessage={() => 'ไม่พบข้อมูลลูกค้า'}
                classNames={{
                  control: () =>
                    clsx('form-control form-control-sm', {
                      'is-invalid': errors.customerTitle,
                    }),
                }}
                formatCreateLabel={(val: any) => `สร้างลูกค้าใหม่ "${val}"`}
                styles={{
                  menu: (provided: any) => ({
                    ...provided,
                    // marginTop: 40,
                  }),
                  control: (provided: any) => ({
                    ...provided,
                    minHeight: 0,
                    padding: 0,
                    borderColor: errors.customerTitle ? 'var(--bs-danger)' : undefined,
                    outlineColor: errors.customerTitle ? 'var(--bs-danger)' : undefined,
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isLoading={isLoadingCustomer}
                loadOptions={onSearchCustomer}
                onChange={(option :any) => {
                  if (option) {
                    const isNewOption = !customerOptions.find(opt => opt.value === option.value)
                    if (isNewOption) {
                      onChange('customerTitle', option ? option.value : '')
                    } else {
                      onSelectCustomer(option)
                    }
                  }
                }}
                onCreateOption={(val: any) => onChange('customerTitle', val)}
              />

              {/* <AsyncSelect
                cacheOptions
                defaultOptions={customerOptions}
                inputValue={formState.customerTitle}
                onInputChange={(val :any) => onChange('customerTitle', val)}
                placeholder='กรุณากรอกชื่อลูกค้า'
                noOptionsMessage={() => 'ไม่พบข้อมูลลูกค้า'}
                menuIsOpen={isFocusCustomer}
                classNames={{
                  control: () =>
                    clsx('form-control form-control-sm', {
                      'is-invalid': errors.customerTitle,
                    }),
                }}
                styles={{
                  menu: (provided  :any) =>  ({
                    ...provided,
                    marginTop: 40,
                  }),
                  control: (provided  :any) =>  ({
                    ...provided,
                    minHeight: 0,
                    padding: 0,
                    borderColor: errors.customerTitle ? 'var(--bs-danger)' : undefined,
                    outlineColor: errors.customerTitle ? 'var(--bs-danger)' : undefined,
                  }),
                }}
                components={{
                  Control: ({ children, ...props }) => null,
                  IndicatorSeparator: () => null,
                }}
                isLoading={isLoadingCustomer}
                loadOptions={onSearchCustomer}
                options={customerOptions}
                onChange={onSelectCustomer}
              />
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': errors.customerTitle,
                })}
                value={formState.customerTitle}
                onChange={(e:any) => {
                  // onSearchCustomer(e.target.value)
                  onChange('customerTitle', e.target.value)
                }}
                onFocus={() => setIsFocusCustomer(true)}
                onBlur={() => setIsFocusCustomer(false)}
              /> */}
            </div>

            <div className='col-12 col-xl-3'>
              <label className='mb-2'>อีเมลลูกค้า</label>
              <input
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': errors.customerEmail,
                })}
                value={formState.customerEmail}
                onChange={(e: any) => onChange('customerEmail', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                วันเริ่มงาน <span className='required' />
              </label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                renderInput={props => {
                  return (
                    <input
                      {...props}
                      autoComplete='off'
                      className={clsx(props.className, {
                        'is-invalid': errors.startJobDate,
                      })}
                    />
                  )
                }}
                closeOnClickOutside
                className='filter-date-input w-100 z-4'
                value={formState.startJobDate}
                onChange={(val: any) => onChange('startJobDate', val)}
              />
            </div>

            <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                วันสิ้นสุดงาน <span className='required' />
              </label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                renderInput={props => {
                  return (
                    <input
                      {...props}
                      autoComplete='off'
                      className={clsx(props.className, {
                        'is-invalid': errors.endJobDate,
                      })}
                    />
                  )
                }}
                closeOnClickOutside
                className='filter-date-input w-100 z-4'
                value={formState.endJobDate}
                onChange={(val: any) => onChange('endJobDate', val)}
              />
            </div>

            <div className='col-12 col-xl-3'>
              <label className='mb-2'>จำนวนวัน</label>
              <div className='position-relative'>
                <input
                  type='text'
                  className='form-control form-control-sm'
                  placeholder='2'
                  value={formState.totalDate}
                  onChange={(e: any) => onChange('totalDate', e.target.value)}
                />
                <div className='position-absolute text-gray-500' style={{ top: '25%', right: 10 }}>
                  (วัน)
                </div>
              </div>
            </div>

            {/* Row 3 */}
            {/* <div className='col-12 col-xl-3'>
              <label className='mb-2'>
                สถานะงาน <span className='required' />
              </label>
              <Select
                isMulti={false}
                styles={{
                  control: (provided  :any) =>  ({
                    ...provided,
                    borderColor: errors.jobStatus ? 'red' : '#e1e3ea',
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={jobStatusOptions}
                value={
                  jobStatusOptions.find(option => option.value === formState.jobStatus) ?? null
                }
                onChange={(option: any) => onChange('jobStatus', option.value)}
              />
            </div> */}

            <div className='col-12 col-xl-9 d-none d-xl-block' />

            {/* Row 4 */}
            <div className='col-12 col-xl-6'>
              <label className='mb-2'>ที่อยู่</label>
              <textarea
                className='form-control form-control-sm'
                rows={13}
                value={formState.address}
                onChange={(e: any) => onChange('address', e.target.value)}
              />
            </div>

            <div className='col-12 col-xl-6'>
              <label className='mb-2'>
                จังหวัด <span className='required' />
              </label>
              <Select
                isMulti={false}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    borderColor: errors.provinceId ? 'red' : '#e1e3ea',
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={provincesOptions}
                value={
                  provincesOptions.find(option => option.value === formState.provinceId) ?? null
                }
                onChange={(option: any) => onChange('provinceId', option.value)}
                className='mb-2'
                placeholder='กรุณาเลือกจังหวัด, เขต/อำเภอ, แขวง/ตำบล'
              />

              <label className='mb-2'>
                เขต/อำเภอ <span className='required' />
              </label>
              <Select
                isMulti={false}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    borderColor: errors.districtId ? 'red' : '#e1e3ea',
                  }),
                }}
                isDisabled={isOversea}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={districtOptions}
                value={
                  districtOptions.find(option => option.value === formState.districtId) ?? null
                }
                onChange={(option: any) => onChange('districtId', option.value)}
                className='mb-2'
                placeholder={isOversea ? '-' : 'กรุณาเลือกจังหวัด, เขต/อำเภอ, แขวง/ตำบล'}
              />

              <label className='mb-2'>
                แขวง/ตำบล <span className='required' />
              </label>
              <Select
                isMulti={false}
                isDisabled={isOversea}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    borderColor: errors.subDistrictId ? 'red' : '#e1e3ea',
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={subDistrictOptions}
                value={
                  subDistrictOptions.find(option => option.value === formState.subDistrictId) ??
                  null
                }
                onChange={(option: any) => onChange('subDistrictId', option.value)}
                className='mb-2'
                placeholder={isOversea ? '-' : 'กรุณาเลือกจังหวัด, เขต/อำเภอ, แขวง/ตำบล'}
              />

              <label className='mb-2'>
                รหัสไปรษณีย์ <span className='required' />
              </label>
              <input
                disabled
                placeholder={isOversea ? '-' : 'กรุณาเลือกจังหวัด, เขต/อำเภอ, แขวง/ตำบล'}
                type='text'
                className={clsx('form-control form-control-sm', {
                  'is-invalid': errors.postCode,
                })}
                value={zipCodeSelected}
                onChange={(e: any) => onChange('postCode', e.target.value)}
              />
            </div>

            {/* Row 5 */}
            {!isCreate && (
              <div className='col-12'>
                <label className='mb-2'>หมายเหตุ</label>
                <textarea
                  className='form-control form-control-sm'
                  rows={5}
                  value={formState.note}
                  onChange={(e: any) => onChange('note', e.target.value)}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {!isCreate && (
        <div className='card border border-2 mt-5'>
          <div className='card-header'>
            <div className='card-title fw-bold'>
              รายการเสา (จำนวนเสาทั้งหมด:{' '}
              {itemsData.reduce((sum: number, curr: any) => (sum += parseInt(curr.quantity)), 0)}{' '}
              ต้น)
            </div>
            <div className='card-toolbar'>
              {!isView && (
                <button className='btn btn-sm btn-primary fw-bold   me-4' onClick={createItem}>
                  เพิ่มรายการเสา
                </button>
              )}
              <button
                className='btn btn-sm btn-primary fw-bold '
                onClick={handleSubmit}
                disabled={disalbedSubmitButton}>
                บันทึก
              </button>
            </div>
          </div>
          <div className='card-body'>
            <ClientSideTable data={itemsData} columns={ITEMS_COLUMNS_CONFIG} items_per_page={10} />
          </div>
        </div>
      )}
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<
  WithChildren & { isCreate: boolean; code: string; version: number }
> = ({ children, isCreate, code, version }) => {
  const headerText = isCreate ? 'เพิ่มใบสั่งขาย' : `ใบสั่งขาย : ${code} version ${version}`

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/sale-order',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'ใบสั่งขาย',
            icon: '/media/icons/duotune/files/fil024.svg',
          },
        ]}>
        {headerText}
      </PageTitle>

      {children}
    </>
  )
}

export default SaleOrderFormView
